<template>
    <aside class="main-sidebar">
        <div v-for="block in navigation" :key="block.name">
            <h4 class="main-sidebar-title" 
                @click="block.open = !block.open" 
                :class="{'open':block.open,'dropdown':block.items.length}">
                {{block.name}}
            </h4>
            <nav v-show="block.open">
                <li v-for="item in block.items" :key="item.title">
                    <router-link :to="item.link">
                        {{item.title}}
                    </router-link>
                </li>
            </nav>
        </div>
        <nav>
            <li>
                <a href="" class="logout" @click.prevent="logOut">Logout</a>
            </li>
        </nav>
    </aside>
</template>

<script>
export default {
  name: 'Navigation',
  data: () => ({
      navigation:[
            {
                name:'Crypto',
                open:false,
                items:[
                {
                    title:'News',
                    link:'/'
                },
                {
                    title:'Dashboard',
                    link:'/dashboard'
                },
                {
                    title:'Live',
                    link:'/live'
                },
                {
                    title:'Summary',
                    link:'/summary'
                },
                {
                    title:'Transactions',
                    link:'/transactions'
                },
                {
                    title:'Indicators',
                    link:'/indicators'
                },
                {
                    title:'Graph',
                    link:'/graph'
                },
                {
                    title:'Mempool',
                    link:'/mempool'
                },
                ]
            },
            {
                name:'US Stocks',
                open:false,
                items:[
                {
                    title:'Score',
                    link:'/score'
                },
                // {
                //     title:'Screener',
                //     link:'/screener'
                // },
                ]
            },
      ]
  }),
  methods:{
      logOut(){
            this.$cookies.remove('auth');
            this.$router.push('/login');
      }
  }
};
</script>
<style lang="scss" scoped>
.main-sidebar{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    min-height: 100%;
    height: 1px;
    margin-left: 0;
    // transition: transform .3s ease;
    transform: translateX(-229px);
    width: 229px;
    padding: 82px 0 36px;
    background-color: var(--input-bg-color);
    &-title{
        font-size: 16px;
        font-weight: 500;
        color: var(--aside-head-font-color);
        line-height: 24px;
        padding-left: 40px;
        cursor: pointer;
        position: relative;
        &.dropdown{
            &:before{
                content: '';
                width: 12px;
                height: 6px;
                background: url('../../assets/img/pointer_2.svg') no-repeat center;
                display: inline-block;
                position: absolute;
                left: 16px;
                top: 9px;
            }
            &.open:before{
                background: url('../../assets/img/minus.svg') no-repeat center;
            }
        }
    }
    nav{
        li{
            list-style-type: none;
            a{
                display: block;
                position: relative;
                padding: 5px 40px;
                font-size: 14px;
                font-weight: 500;
                color: var(--aside-font-color);
                border-top: 1px solid transparent;
                border-bottom: 1px solid transparent;
                border-left: 3px solid transparent;
                text-decoration: none;
                cursor: pointer;
                transition: all .2s ease;
                transform: none;
                &:hover{
                    background: var(--aside-active-item-bg);
                }
                &.router-link-exact-active{
                        border-left-color: #597DFF;
                        color: #597DFF;
                }
                &.logout{
                    font-size: 16px;
                    color: #D63C6A;
                }
            }
        }
    }
}
</style>